export abstract class BaseSerializer {
  public static serialize(model: any, omit: any[] = []) {
    const jsonString = JSON.stringify(model, (key, value) => {
      // Check if key matches anything in omit.
      // if matched return value "undefined"
      if (omit.includes(key)) {
        return undefined;
      }
      // else return the value itself

      return value;
    });

    return jsonString;
  }

  abstract deserialize(data: any): any;

  deserializeList(data: any): any[] {
    if (data === undefined) return [];

    const itemList: any[] = [];
    for (const dataItem of data) {
      const item = this.deserialize(dataItem);
      itemList.push(item);
    }

    return itemList;
  }

  _normalizeSource(source: any): any {
    if (source == null) return source;

    // Ensure id is a string
    if (source.id) {
      source.id = source.id.toString();
    }

    // Flatten layer_properties_object into source
    const lpo = source["layer_properties_object"];
    if (lpo != null) {
      if (lpo["color_value"]) {
        lpo["color"] = lpo["color_value"];
      }

      const subId = lpo.id;
      delete lpo.id;

      // Copy all keys from layer_properties_object into source
      Object.assign(source, lpo);

      // Restore the id into nested object
      source.layer_properties_object = {
        ...lpo,
        id: subId,
      };
    }

    return source;
  }

  _copyAttributes(target: any, source: any) {
    if (source === null || source === undefined) {
      return target;
    }
    Object.keys(target).forEach((key: string) => {
      if (
        Object.prototype.hasOwnProperty.call(source, key) &&
        source[key] != null &&
        source[key] !== ""
      ) {
        if (key == "id" || key == "parent_id")
          target[key] = source[key].toString();
        else target[key] = source[key];
      }
    });

    return target;
  }

  _copyAttributesDropDown(target: any, source: any) {
    if (source === null || source === undefined) {
      return target;
    }
    Object.keys(target).forEach((key: string) => {
      if (
        Object.prototype.hasOwnProperty.call(source, key) &&
        source[key] != null &&
        source[key] !== ""
      ) {
        if (key == "code") target["value"] = source["code"];
        else target["value"] = source["id"];
        target["label"] = source["value"];
      }
    });

    return target;
  }
  _copyAttributesUserNameDropDown(target: any, source: any) {
    if (source === null || source === undefined) {
      return target;
    }
    Object.keys(target).forEach((key: string) => {
      if (
        Object.prototype.hasOwnProperty.call(source, key) &&
        source[key] != null &&
        source[key] !== ""
      ) {
        target["value"] = source["id"];
        target["label"] = `${source["first_name"]} ${source["last_name"]}`;
        target["email"] = source["email"];
        target["userType"] = source["user_type"];
      }
    });

    return target;
  }

  _copyAttributesValue(target: any, source: any) {
    if (source === null || source === undefined) {
      return target;
    }
    Object.keys(target).forEach((key: string) => {
      if (
        Object.prototype.hasOwnProperty.call(source, key) &&
        source[key] != null &&
        source[key] !== ""
      ) {
        if (key == "value") {
          target[key] = source["id"];
          target["label"] = source["value"];
        } else target[key] = source[key];
      }
    });

    return target;
  }
}
